import {RenderingServices, utils} from '@wallaby-ui/core';
import {CSSProperties} from 'react';
import {defineMessages} from 'react-intl';

import {EncounterTimelineEventAnnotation} from 'src/js/model/encounter_timeline';

const SELECTED_TABS = {encounter: 1};

const I18N = defineMessages({
  OPEN_LINK: {
    id: 'case.timeline.annotation.openLink',
    defaultMessage: 'Open document',
    description: 'title for case timeline annotation open link',
  },
});

export interface BaseEventAnnotationParams {
  annotation: EncounterTimelineEventAnnotation;
  encounterId: string | undefined;
  queryParameters: {selectedTabs?: string};
}

export interface BaseEventAnnotationParamsReturnType
  extends BaseEventAnnotationParams {
  colorStyle: CSSProperties;
  label?: string;
  searchParams?: Record<string, string | undefined | null>;
  titleText?: string;
  documentId: string | null | undefined;
}

export function baseEventAnnotationParams(
  params: BaseEventAnnotationParams,
  services: RenderingServices = {}
): BaseEventAnnotationParamsReturnType {
  const {intl, routeParams} = services;
  const {annotation, queryParameters = undefined} = params;
  const colorStyle = {
    color:
      EncounterTimelineEventAnnotation.isNotEmptyStyle(annotation.getStyle()) &&
      annotation.getStyle().color
        ? annotation.getStyle().color
        : 'inherit',
  };
  const searchParams = {
    ...queryParameters,
    // default tab can be overridden by query parameters
    selectedTabs:
      queryParameters?.selectedTabs || JSON.stringify(SELECTED_TABS),
  };
  const encounterId = routeParams?.encounterId;
  const documentId = annotation.getDocumentId();

  const titleText =
    intl &&
    `${intl?.formatMessage(I18N.OPEN_LINK)} - ${utils.TranslateUtils.translate(
      annotation.getLabel() ?? '',
      intl
    )}`;
  const label =
    intl && utils.TranslateUtils.translate(annotation.getLabel() ?? '', intl);

  return {
    ...params,
    colorStyle,
    label,
    searchParams,
    titleText,
    encounterId,
    documentId,
  };
}
